<template>
  <div>
    <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
        <v-select
          outlined
          v-model="SelStatus"
          :items="StatusName"
          item-text="event_name"
          item-value="event_id"
          label="Select Event"
          dense
          :rules="[(v) => !!v || 'Event is required']"
          required
          return-object
          @change="clearData"
          hide-details
          full-width
        ></v-select>
        <v-btn color="primary" class="ml-3" raised dark large @click="load">
          RELOAD2
        </v-btn>
        <v-btn
          color="success"
          class="ml-3"
          raised
          dark
          large
          @click="savechanges"
        >
          SAVE CHANGES
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Choose Card(s)</v-card-text>

          <v-data-table
            v-model="selected"
            :headers="hdrreason"
            :items="arrreason"
            item-key="jobtype_name"
            show-select
            @click:row="handleClick"
            dense
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Selected Job type(s)</v-card-text>
          <v-data-table
            :headers="hdr1reason"
            :items="selected"
            item-key="jobtype_name"
            dense
            :loading="loading"
            :search="search1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search1"
                label="Search"
                single-line
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.jobtype_name }}</td>
                <!-- <td>{{ item.role_name }}</td> -->
              </tr>
            </template>
            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
    loading: false,
    checkbox: "",
    chkselected: "",
    selected: [],
    StatusName: [],
    SelStatus: "",
    search: "",
    search1: "",
    btrue: true,
    inputclass: {
      event_id: "",
      jobtype_name: [],
    },

    arrreason: [],
    hdrreason: [
      // { text: "ID", value: "mc_id" },
      { text: "JOB TYPE NAME", value: "jobtype_name" },
    ],

    arr1reason: [],
    hdr1reason: [
    //   { text: "ID", value: "status_id" },
    //   { text: "SELECTED STATUS", value: "status_name" },
    { text: "SELECTED JOB TYPE", value: "jobtype_name" },
    ],

    editedItem: {
      reason_id: "",
      reason_name: 0,
      status_id: 0,
      mapping_status: false,
    },
  }),
  mounted() {
    this.bindcompanytype();
    // this.Gridbindjobtype();
    // this.Gridbindjobtype(4);
  },
  watch: {
    selected: function () {
    },
    bindcompanytype: function(){
      
    }

  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    addvalue: function (id, name, cid, status) {
      alert(id + " " + name + " " + cid + " " + status);
      this.editedItem.reason_id = id;
      this.editedItem.reason_name = name;
      this.editedItem.status_id = cid;
      this.editedItem.mapping_status = "true";
      this.arr1reason.push(this.editedItem);
      //  this.arr1jobtype.splice()
    },
    clearData: function () {
      this.arrreason = [];
      this.selected = [];
    },
    load: function () {
      //alert(this.SelCompany.companytype_id)
      this.selected = [];
      this.loading = true;
      this.Gridbindjobtype(this.SelStatus.event_id);
    },
    savechanges: function () {
      if(this.selected.length<=0)
      {
        this.showSnackbar("error", "Select Job type before save !");
      return;
      }
      this.inputclass.jobtype_name = [];
      this.selected.forEach((el) => {
        this.inputclass.jobtype_name.push(el.jobtype_name);
      });
      this.inputclass.event_id = this.SelStatus.event_id;

      axios
        .post(this.$apiPath + "Media/mediajobtypemap", this.inputclass, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.showSnackbar("Success", "Job type and  Event merged !");
            this.Reload();
          }
        })
        .catch()
        .finally();
    },

    handleClick(value) {
      alert(value);
    },
    bindcompanytype: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.StatusName = res.data.result;
        })
        .catch()
        .finally();
    },

    Gridbindjobtype: async function (comid) {
      await axios
        .get(this.$apiPath + "Media/mediajobtypemappinglist/" + comid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrreason = res.data.result;
          this.selected = this.arrreason.filter(
            (task) => task.event_id == this.SelStatus.event_id
          );
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>